import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CookieService {
  public setCookie(name: string, value: string, exdays: number) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    const expires = 'expires=' + d.toUTCString();
    document.cookie = `${name}=${value};${expires};path=/`;
  }

  public getCookie(name: string) {
    const cname = name + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let c of ca) {
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }

    return '';
  }

  public checkCookie(name: string): boolean {
    const cname = this.getCookie(name);
    if (!this.isEmpty(cname)) {
      return true;
    } else {
      return false;
    }
  }

  private isEmpty(value: any) {
    return value === undefined || value === null || value === '';
  }
}
